module.exports = __webpack_public_path__ + "static/media/BE.e4d1e403.png";